export default __webpack_public_path__ + "static/media/jcbLogo.488dfd7c.svg";